import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { LoadingScreenService } from '@shared/services/loading-screen.service';

@Component({
    selector: 'loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit {

    visible = false;
    fadeIn = false;
    messageKey?: string;

    @ViewChild('overlay') overlayRef!: ElementRef;
    private lastFocusedElement: HTMLElement | null = null;

    constructor(
        private readonly loadingScreenService: LoadingScreenService,
        private readonly renderer: Renderer2
    ) { }

    ngOnInit() {
        this.loadingScreenService.loadingScreenEventEmitter.subscribe(({ visible, messageKey }) => {
            this.visible = visible;
            this.messageKey = messageKey;

            if (visible) {
                this.fadeIn = false;
                requestAnimationFrame(() => this.fadeIn = true);

                this.lastFocusedElement = document.activeElement as HTMLElement;
                this.renderer.addClass(document.body, 'loading-screen-is-open');
                setTimeout(() => this.overlayRef?.nativeElement.focus());

                const main = document.querySelector('main');
                const loadingScreen = document.querySelector('loading-screen');

                if (main && loadingScreen) {
                    Array.from(main.children).forEach(child => {
                        if (child !== loadingScreen) {
                            this.renderer.setAttribute(child, 'inert', 'true');
                        }
                    });
                }
            } else {
                this.fadeIn = false;

                const main = document.querySelector('main');
                if (main) {
                    Array.from(main.children).forEach(child => {
                        this.renderer.removeAttribute(child, 'inert');
                    });
                }

                this.renderer.removeClass(document.body, 'loading-screen-is-open');
                this.lastFocusedElement?.focus();
            }
        });
    }
}
